  export function getCurrencySymbol(code, locale) {
  const f = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
    currencyDisplay: 'narrowSymbol', // e.g. "£" instead of "GBP"
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  const parts = f.formatToParts(0);
  return parts.find(p => p.type === 'currency')?.value ?? code;
}

export function formatMinor(minor, code, locale) {
  const currency = code?.toUpperCase();

  // If no locale OR you want currency-driven formatting, map it here
  const resolvedLocale = locale || getLocaleFromCurrency(currency);

  const f = new Intl.NumberFormat(resolvedLocale, {
    style: 'currency',
    currency
  });

  const { minimumFractionDigits } = f.resolvedOptions();
  const major = minor / Math.pow(10, minimumFractionDigits);

  return f.format(major);
}

function getLocaleFromCurrency(currency) {
  switch (currency) {
    case "GBP":
      return "en-GB";
    case "EUR":
      return "es-ES"; // or "en-IE" depending on your preference
    default:
      return "en-GB";
  }
}